import React from 'react';

const DropDown = () =>
(<svg xmlns="http://www.w3.org/2000/svg" width="7" height="5" viewBox="0 0 7 5" alt="Vis"><path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" d="M1 1l2.5 2.5L6 1"/></svg>)
export default DropDown;